<svelte:options customElement="hb-offcanvas" />

<script lang="ts">
  /**
   * Offcanvas drawer web component (hosts hb-sidebar-desktop).
   * =====================
   *
   * @contributors: Dario Caruso <dev@dariocaruso.info> (https://dariocaruso.info)
   *
   * @license: MIT License
   *
   */

  import pkg from "../../../package.json";
  import type { INavLink } from "../sidenav-link/types/webcomponent.type";

  import type { Component } from "./types/webcomponent.type";
  import { addComponent } from "wc-js-utils";
  import type { Events as SidebarDesktopEvents } from "../sidebar-desktop/types/webcomponent.type";

  let {
    id,
    // style = "",
    type = "autohide",
    navlinks = undefined,
    companylogouri = "",
    navpage = "home",
    groups = [],
    opened = false,
    companytitle = "",
    enablefooter = undefined as Component["enablefooter"],
    enablethemeswitch = "yes",
    themepreference = undefined as Component["themepreference"],
    i18nlang = "",
    i18nlanguages = undefined as Component["i18nlanguages"],
  }: Component = $props();

  /** Footer chrome on nested hb-sidebar-desktop (`yes` unless explicitly disabled). */
  let enable_footer_for_sidebar = $derived.by(() => {
    const v: unknown = enablefooter;
    const hide =
      v === false || v === "no" || v === "false" || String(v) === "false";
    return hide ? "no" : "yes";
  });

  let switched = $state(false);
  $effect(() => {
    // if (style) {
    //     sidenavLinkStyleSetup?.vars
    //   );
    //     sidebarDesktopStyleSetup?.vars
    //   );
    // }

    if (!companytitle) companytitle = "";
    if (type === "open" || (opened && (opened as unknown as string) !== "no")) {
      opened = true;
      if (!switched)
        dispatch("offcanvasswitch", {
          isOpen: opened,
        });
      switched = true;
    } else {
      opened = false;
    }

    try {
      if (typeof groups === "string") {
        groups = JSON.parse(groups);
      }
    } catch (err) {}
  });

  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }
  function changePage(page: string) {
    console.log(page);
    dispatch("pageChange", {
      page,
    });
    OpenSwitch(false);
  }
  function OpenSwitch(open: boolean) {
    opened = open;
    switched = false;

    dispatch("offcanvasswitch", {
      isOpen: opened,
    });
  }

  addComponent({
    repoName: "@htmlbricks/hb-sidenav-link",
    version: pkg.version,
  });
  addComponent({
    repoName: "@htmlbricks/hb-sidebar-desktop",
    version: pkg.version,
  });
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdn.jsdelivr.net/npm/bootstrap-icons@latest/font/bootstrap-icons.css"
  />
</svelte:head>
<div id="webcomponent">
  <slot name="test" />
  <div
    class="hb-offcanvas-panel"
    class:hb-offcanvas-panel--open={opened}
    tabindex="-1"
    aria-labelledby="offcanvasExampleLabel"
  >
    <hb-sidebar-desktop
      onpageChange={(e: { detail: SidebarDesktopEvents["pageChange"] }) =>
        dispatch("pageChange", e.detail)}
      onlanguageChange={(e: {
        detail: SidebarDesktopEvents["languageChange"];
      }) => dispatch("languageChange", e.detail)}
      onthemeChange={(e: {
        detail: SidebarDesktopEvents["themeChange"];
      }) => dispatch("themeChange", e.detail)}
      {navlinks}
      {navpage}
      {companytitle}
      companylogouri={companylogouri}
      {groups}
      enablefooter={enable_footer_for_sidebar}
      enablethemeswitch={enablethemeswitch || "yes"}
      {themepreference}
      i18nlang={i18nlang || ""}
      {i18nlanguages}
    ></hb-sidebar-desktop>
  </div>
  {#if type === "autohide"}
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <!-- svelte-ignore a11y_no_static_element_interactions -->
    <div
      role="presentation"
      onclick={() => OpenSwitch(false)}
      class="modal-background hb-offcanvas-backdrop"
      class:is-hidden={!opened}
    ></div>
  {/if}
</div>

<style lang="scss">
  @forward "./styles/bulma.scss";
  @forward "./styles/webcomponent.scss";
</style>
